import {deserializeAs} from 'cerialize';
import {SituationCompteur} from './SituationCompteur';
import {CaracteristiquesCompteur} from './CaracteristiquesCompteur';
import {Pitd} from './pitd';

export class DonneesTechniques {
  @deserializeAs(SituationCompteur, 'situation_compteur')
  situationCompteur: SituationCompteur;

  @deserializeAs(CaracteristiquesCompteur, 'caracteristiques_compteur')
  caracteristiquesCompteur: CaracteristiquesCompteur;

  @deserializeAs(Pitd, 'pitd')
  pitd: Pitd;
}
